import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import {
  getCategoriesError,
  getCategoriesStatus,
  getCategoriesLoading,
  getCategoriesSuccess,
  modifyCategory,
} from "../../../features/categorySlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import CategoryForm from "./categoryForm";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const ModifyCategory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { restaurantId } = useRestaurant();
  const data = location.state.category;
  const [previewImage, setPreviewImage] = useState(null);
  const status = useSelector(getCategoriesStatus);
  const error = useSelector(getCategoriesError);
  const success = useSelector(getCategoriesSuccess);
  const loading = useSelector(getCategoriesLoading);
  
  const initialValues = {
    name: data.name,
  };
  
  const handleFormSubmit = (values) => {
    const requestBody = {
      name: values.name,
      ...getImageFormFields(previewImage),
    };
    dispatch(
      modifyCategory({
        body: requestBody,
        categoryId: data._id,
        restaurantId: restaurantId,
      })
    );
  };

  useEffect(() => {
    if (status === "modifySuccess") {
      toast.success(success);
      navigate("/category");
    } else if (status === "modifyError") {
      toast.error(error);
    }
  }, [status, error, success, dispatch, navigate]);

  return (
    <Box m="20px" className="main-application">
      <BackButton/>
      <Header title={t("headers.editCategory")} subtitle={t("headers.editCategorySub")} />
      <CategoryForm
        buttonText={t("common.edit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        loading={loading}
        image={data.image}
      />
    </Box>
  );
};

export default ModifyCategory;
